import { getFilters, getFiltersAxios } from '@/api/filters.js';
import {
    filterNoChild,
    filterItem,
    searchFilterItemPath,
    searchFilterPath,
    sortFilterByName,
} from '@/scripts/tools.js';

export default {
    state: {
        filters: {},
        filterNoChild: {},
        filterItem: {},

        isShowFilterAdd: false,
        isSaveFilterAdd: false,
        filterDataAdd: {
            name: '',
            description: '',
            asset_type_id: null,
            parent_id: 'None',
            is_required: false,
            is_multiple: false,
            have_sub_filter: false,
            filter_type: 'checkbox',
        },

        isShowFilterEdit: false,
        isSaveFilterEdit: false,
        filterDataEdit: null,

        isShowFilterItemAdd: false,
        isSaveFilterItemAdd: false,
        filterItemDataAdd: {
            name: '',
            asset_type_id: null,
            filter_id: 'None',
            is_default: false,
            parent_ids: [],
        },

        isShowFilterItemEdit: false,
        isSaveFilterItemEdit: false,
        filterItemDataEdit: null,
    },
    getters: {
        FILTERS: (state) => {
            return state.filters;
        },
        FILTER_BY_ID: (state) => (assetID, filterID) => {
            let noChildFilter = null;
            if (state.filterNoChild[assetID] == null) {
                const clearFilterList = filterNoChild(state.filters[assetID]);
                state.filterNoChild[assetID] = clearFilterList;
                noChildFilter = clearFilterList;
            } else {
                noChildFilter = state.filterNoChild[assetID];
            }
            const filterIndex = noChildFilter
                .map((filter) => filter.id)
                .indexOf(filterID);
            if (filterIndex >= 0) {
                return noChildFilter[filterIndex];
            } else {
                return null;
            }
        },
        FILTERS_NO_CHILD: (state) => (id) => {
            if (id == null || id === 'all') return [];
            if (state.filterNoChild[id] == null) {
                const noChildFilter = filterNoChild(state.filters[id]);
                state.filterNoChild[id] = noChildFilter;
                return noChildFilter;
            } else {
                return state.filterNoChild[id];
            }
        },
        FILTER_BY_ASSET_TYPE: (state) => (id) => {
            const filter = state.filters[id];
            return filter == null ? [] : filter;
        },
        FILTER_PARENT_FILTER: (state) => (id, value) => {
            if (id < 1 || id == null || id === 'all') return [];

            let filterList = null;
            if (value === true) {
                filterList = state.filters[id];
            } else {
                if (state.filterNoChild[id] == null) {
                    const noChildFilter = filterNoChild(state.filters[id]);
                    state.filterNoChild[id] = noChildFilter;
                    filterList = noChildFilter;
                } else {
                    filterList = state.filterNoChild[id];
                }
            }
            const filter = filterList.filter(
                (filter) => filter.have_sub_filter === value
            );
            return filter;
        },
        FILTER_ITEM: (state) => (id) => {
            if (id < 1 || id == null) return [];

            if (state.filterItem[id] == null) {
                const filterItemList = filterItem(state.filters[id]);
                state.filterItem[id] = filterItemList;
                return filterItemList;
            } else {
                return state.filterItem[id];
            }
        },
        FILTER_ITEM_ID: (state) => (assetID, filterItemID) => {
            if (assetID <= 0 || assetID == null) return [];
            if (filterItemID <= 0 || filterItemID == null) return [];

            let filterList = null;
            if (state.filterItem[assetID] == null) {
                const filterItemList = filterItem(state.filters[assetID]);
                state.filterItem[assetID] = filterItemList;
                filterList = filterItemList;
            } else {
                filterList = state.filterItem[assetID];
            }

            const filterItemIndex = filterList
                .map((filterItem) => filterItem.id)
                .indexOf(filterItemID);
            return filterItemIndex !== -1 ? filterList[filterItemIndex] : null;
        },

        IS_SHOW_FILTER_ADD: (state) => {
            return state.isShowFilterAdd;
        },
        IS_SAVE_FILTER_ADD: (state) => {
            return state.isSaveFilterAdd;
        },
        FILTER_DATA_ADD: (state) => {
            return state.filterDataAdd;
        },

        IS_SHOW_FILTER_EDIT: (state) => {
            return state.isShowFilterEdit;
        },
        IS_SAVE_FILTER_EDIT: (state) => {
            return state.isSaveFilterEdit;
        },
        FILTER_DATA_EDIT: (state) => {
            return state.filterDataEdit;
        },

        IS_SHOW_FILTER_ITEM_ADD: (state) => {
            return state.isShowFilterItemAdd;
        },
        IS_SAVE_FILTER_ITEM_ADD: (state) => {
            return state.isSaveFilterItemAdd;
        },
        FILTER_ITEM_DATA_ADD: (state) => {
            return state.filterItemDataAdd;
        },

        IS_SHOW_FILTER_ITEM_EDIT: (state) => {
            return state.isShowFilterItemEdit;
        },
        IS_SAVE_FILTER_ITEM_EDIT: (state) => {
            return state.isSaveFilterItemEdit;
        },
        FILTER_ITEM_DATA_EDIT: (state) => {
            return state.filterItemDataEdit;
        },
    },
    mutations: {
        FILTERS: (state, payload) => {
            state.filters = payload;
        },
        FILTERS_ADD: (state, payload) => {
            if (payload.length === 0) return;

            sortFilterByName(payload);
            state.filters[payload[0].asset_type_id] = payload;
        },
        FILTERS_PUSH: (state, { assetID, payload, parentID }) => {
            let filter = null;
            if (parentID == null) {
                filter = state.filters[assetID];
            } else {
                const filterIndex = state.filters[assetID]
                    .map((filter) => filter.id)
                    .indexOf(parentID);
                if (filterIndex >= 0) {
                    filter =
                        state.filters[assetID][filterIndex].children_filter;
                }
            }
            filter.push(payload);
        },
        FILTER_SPLICE: (state, { assetID, filterID }) => {
            const path = searchFilterPath(state.filters[assetID], filterID);
            if (path.filterIndex == null) return;
            if (path.filter != null) {
                state.filters[assetID][path.filter].children_filter.splice(
                    path.filterIndex,
                    1
                );
            } else {
                state.filters[assetID].splice(path.filterIndex, 1);
            }

            if (state.filterNoChild[assetID] != null) {
                const filterIndex = state.filterNoChild[assetID]
                    .map((filter) => filter.id)
                    .indexOf(filterID);
                if (filterIndex >= 0)
                    state.filterNoChild[assetID].splice(filterIndex, 1);
            }
        },
        FILTER_ITEM_SPLICE: (state, { assetID, filterItemID }) => {
            const path = searchFilterItemPath(
                state.filters[assetID],
                filterItemID
            );
            if (path.filter == null) return;
            if (path.childFilter != null) {
                state.filters[assetID][path.filter].children_filter[
                    path.childFilter
                ].filter_items.splice(path.filterIndex, 1);
            } else {
                state.filters[assetID][path.filter].filter_items.splice(
                    path.filterIndex,
                    1
                );
            }

            if (state.filterNoChild[assetID] != null) {
                for (let i = 0; i < state.filterNoChild[assetID].length; i++) {
                    const filterItemIndex = state.filterNoChild[assetID][
                        i
                    ].filter_items
                        .map((filterItem) => filterItem.id)
                        .indexOf(filterItemID);
                    if (filterItemIndex >= 0) {
                        state.filterNoChild[assetID][i].filter_items.splice(
                            filterItemIndex,
                            1
                        );
                        break;
                    }
                }
            }

            if (state.filterItem[assetID] != null) {
                const filterItemIndex = state.filterItem[assetID]
                    .map((filterItem) => filterItem.id)
                    .indexOf(filterItemID);
                if (filterItemIndex >= 0)
                    state.filterItem[assetID].splice(filterItemIndex, 1);
            }
        },

        IS_SHOW_FILTER_ADD: (state, payload) => {
            state.isShowFilterAdd = payload;
        },
        IS_SAVE_FILTER_ADD: (state, payload) => {
            state.isSaveFilterAdd = payload;
        },
        FILTER_DATA_ADD_UPDATE: (state, { fieldName, fieldValue }) => {
            state.filterDataAdd[fieldName] = fieldValue;
        },

        IS_SHOW_FILTER_EDIT: (state, payload) => {
            state.isShowFilterEdit = payload;
        },
        IS_SAVE_FILTER_EDIT: (state, payload) => {
            state.isSaveFilterEdit = payload;
        },
        FILTER_DATA_EDIT_SET: (state, payload) => {
            state.filterDataEdit = structuredClone(payload);
        },
        FILTER_DATA_EDIT_UPDATE: (state, { fieldName, fieldValue }) => {
            state.filterDataEdit[fieldName] = fieldValue;
        },

        IS_SHOW_FILTER_ITEM_ADD: (state, payload) => {
            state.isShowFilterItemAdd = payload;
        },
        IS_SAVE_FILTER_ITEM_ADD: (state, payload) => {
            state.isSaveFilterItemAdd = payload;
        },
        FILTER_ITEM_DATA_ADD_UPDATE: (state, { fieldName, fieldValue }) => {
            state.filterItemDataAdd[fieldName] = fieldValue;
        },

        IS_SHOW_FILTER_ITEM_EDIT: (state, payload) => {
            state.isShowFilterItemEdit = payload;
        },
        IS_SAVE_FILTER_ITEM_EDIT: (state, payload) => {
            state.isSaveFilterItemEdit = payload;
        },
        FILTER_ITEM_DATA_EDIT_SET: (state, { assetID, payload }) => {
            const clonePayload = structuredClone(payload);
            clonePayload['asset_type_id'] = assetID;
            state.filterItemDataEdit = clonePayload;
        },
        FILTER_ITEM_DATA_EDIT_UPDATE: (state, { fieldName, fieldValue }) => {
            state.filterItemDataEdit[fieldName] = fieldValue;
        },
    },
    actions: {
        CHECK_FILTERS: async function (context) {
            if (context.getters.FILTERS.length === 0) {
                context.commit('FILTERS', await getFilters());
            }
        },
        CHECK_FILTERS_AXIOS: async function (context) {
            const filters = context.getters.FILTERS;
            if (Object.keys(filters).length === 0) {
                const axiosPromise = await getFiltersAxios().catch((error) => {
                    return [];
                });
                return axiosPromise;
            }
            return [];
        },
        CHECK_FILTER_ADD: async function (context) {
            const data = context.getters.FILTER_DATA_ADD;

            if (data.name === '') {
                context.commit('IS_SAVE_FILTER_ADD', false);
                return 'To create a filter, enter a name';
            }

            context.commit('IS_SAVE_FILTER_ADD', true);
            return '';
        },
        CHECK_FILTER_EDIT: async function (context) {
            const data = context.getters.FILTER_DATA_EDIT;

            if (data.name === '') {
                context.commit('IS_SAVE_FILTER_EDIT', false);
                return 'To save a filter, enter a name';
            }

            context.commit('IS_SAVE_FILTER_EDIT', true);
            return '';
        },
        CHECK_FILTER_ITEM_ADD: async function (context) {
            const data = context.getters.FILTER_ITEM_DATA_ADD;

            if (data.name === '') {
                context.commit('IS_SAVE_FILTER_ITEM_ADD', false);
                return 'To create a filter item, enter a name';
            }

            if (data.filter_id === 'None' || data.filter_id == null) {
                context.commit('IS_SAVE_FILTER_ITEM_ADD', false);
                return 'To create a filter item, select a filter';
            }

            context.commit('IS_SAVE_FILTER_ITEM_ADD', true);
            return '';
        },
        CHECK_FILTER_ITEM_EDIT: async function (context) {
            const data = context.getters.FILTER_ITEM_DATA_EDIT;

            if (data.name === '') {
                context.commit('IS_SAVE_FILTER_ITEM_EDIT', false);
                return 'To save a filter item, enter a name';
            }

            context.commit('IS_SAVE_FILTER_ITEM_EDIT', true);
            return '';
        },
    },
};
